import { TaskEither, Either, right, left, taskEither } from '@shared-commons/utils';
import { GetInstrumentsResponse, GetInstrumentsResponseSchema } from '../types';

// ***** 1. Adapter: converte il JSON generico in un oggetto partial "CreateProfileResponse"e
export const getInstrumentsAdapter = (input: any): TaskEither<Error, GetInstrumentsResponse> => {
  const task = async (): Promise<Either<Error, GetInstrumentsResponse>> => {
    try {
      const adaptedInstruments = Array.isArray(input)
        ? input.map((inst: any) => {
            // Se icon esiste ed è un oggetto, ma non contiene alcuna chiave, impostalo a null
            if (inst.icon && typeof inst.icon === 'object' && Object.keys(inst.icon).length === 0) {
              return { ...inst, icon: null };
            }
            return inst;
          })
        : input;
      return right({
        success: true,
        instruments: adaptedInstruments,
        message: 'Instruments fetched successfully',
        error: undefined,
      });
    } catch (error) {
      return left(
        new Error('Failed to adapt create-profile response: ' + (error as Error).message),
      );
    }
  };
  return taskEither(task);
};
